var _circle, _path, _path2, _path3, _path4, _path5, _circle2, _circle3, _circle4, _path6, _path7, _path8, _circle5, _circle6, _circle7, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordChanged(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 82,
    viewBox: "0 0 102 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.3696,
    cy: 40.7407,
    r: 40.7407,
    fill: "#EBF1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7031 63.3335H69.629",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5918 63.3335H82.2214",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.334 67.7778H31.8525",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7031 67.7778H43.7031",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0371 67.4077H72.963",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.1114,
    cy: 25.9261,
    r: 2.46296,
    stroke: "#5290DC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.96296,
    cy: 14.074,
    r: 2.46296,
    stroke: "#5290DC"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.2227,
    cy: 25.9261,
    r: 2.46296,
    stroke: "#5290DC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6953 12.4421V11.3757H14.4629V8.58911H15.5483V11.3757H18.3159V12.4421H15.5483V15.2224H14.4629V12.4421H11.6953Z",
    fill: "#5290DC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6953 51.7012V50.6348H94.4629V47.8481H95.5483V50.6348H98.3159V51.7012H95.5483V54.4814H94.4629V51.7012H91.6953Z",
    fill: "#5290DC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6582 36.8865V35.8201H97.4258V33.0334H98.5112V35.8201H101.279V36.8865H98.5112V39.6667H97.4258V36.8865H94.6582Z",
    fill: "#5290DC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.92535,
    cy: 38.5186,
    r: 1.72222,
    stroke: "#5290DC"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.0738,
    cy: 59.6299,
    r: 1.72222,
    stroke: "#5290DC"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.0738,
    cy: 8.88897,
    r: 1.72222,
    stroke: "#5290DC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42 37.1474L47.4572 44.6316L63.8289 28",
    stroke: "#5290DC",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordChanged);
export default __webpack_public_path__ + "static/media/passwordChanged.ae0d13a2b076d8fbc367b802c916cfbf.svg";
export { ForwardRef as ReactComponent };